export const productPrice = (
  price: number,
  quantity: number,
  wholesale?: number,
) => {
  return wholesale !== undefined ? wholesale * quantity : price * quantity;
};
